namespace Gordic.Uda.WebControls {
    let gcontent = Decorators.gcontent;

    /**
     * SeznamVyveseni
     *
     * @author Jindřich Vácha
     * @since 480.2.0.0
     */
    @gcontent
    export class SeznamVyveseni extends GContentBase {

        /**
         * Filtr nad gridem
         * @type {JQuery}
         */
        private $filterForm: JQuery;

        /**
         * Aktuální hodnoty filtru
         * @type {Gordic.Uda.Interface.SeznamDokumentuUDFilterDto | null}
         */
        private currentFilter: Gordic.Uda.Interface.SeznamDokumentuUDFilterDto | null;

        /**
         * Grid se seznamem
         * @type {JQuery}
         */
        private $grid: JQuery;

        /**
         * model
         * @type {Gordic.Uda.WebControls.SeznamVyveseniDto}
         */
        protected model: Gordic.Uda.WebControls.SeznamVyveseniDto;

        //-----------------------------------------------------------------------------------------------------
        /**
         * Definice formuláře
         */
        public onContentReady(): void {

            this.taskId = "actSeznamVyveseni";

            let that = this;

            console.log("Gordic.Uda.WebControls.SeznamVyveseni.onContentReady", this);

            // akce seznamu
            this.actions.addRange({
                actSample: {
                    name: "actSample",
                    caption: "Sample " + this.model.ixp,
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        alert(1);
                    }
                }
            });

            this.menuBar(this.actions.createBar(["actSample*"]));

            // aktuální filtr
            this.currentFilter = null;

            var filterFormDef = new Gordic.Forms.Form({ tabLabel: "Kompletní filtr" })
                .addSection()
                .addRow("ixs_ulo").addField("gstringbox", { name: "ixs_ulo" })
                .addRow("por_cislo").addField("gnumberbox", { name: "por_cislo" })
            ;

            this.$filterForm = $("<div>").appendTo(this.element)
                .gfilterpanel({
                    forms: [filterFormDef],
                    favorites: ["ixs_ulo"],
                    favoriteLayoutDescriptor: "L4M3S1",
                    tema: "ude_sez_vyv",
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store(),
                    saveOptionsForm: "all",
                    searchButtonOnMainRow: true,
                    apply: function (event, obj) {
                        // načtení dat podle filtrů
                        that.nacteniSeznamu(obj.filter);
                    }
                });

            // vytvoření gridu
            this.$grid = $("<div>")
                .appendTo(that.element)
                .ggrid<Gordic.Uda.Interface.SeznamDokumentuUDDto>({
                    multi: true,
                    searchColumns: ["nazev", "popis", "nazev_ref", "zmenu_prov_txt"],
                    columns:
                        new Gordic.Data.GridFormat()
                            .addTextColumn({
                                name: "ixs_ulo",
                                caption: "ixs_ulo_c",
                                width: 120,
                                fixedWidth: true
                                //customClass: "ui-disabled"
                            })
                            .addTextColumn({
                                name: "por_cislo",
                                caption: "por_cislo_c",
                                fixedWidth: true,
                                width: 50
                            })
                            .addIconColumn({
                                caption: "Stav",
                                name: "s_ude",
                                iconTemplate: function (row) {
                                    let s_ude = row.s_ude;
                                    let stav = row.stav;

                                    if (s_ude != null && stav != null) {
                                        switch (s_ude) {
                                            case 0: return {
                                                icon: "gi-paper" /*gi-paper2-02 "fa-file-o"*/, tooltip: stav
                                            }; // návrh
                                            case 10: return {
                                                icon: "gi-tick" /*"fa-file-text-o" */, tooltip: stav
                                            }; // vyvěšeno
                                            case 20: return {
                                                icon: "gi-bin" /*gi-window-close" /*"fa-file" */, tooltip: stav
                                            }; // zrušeno
                                            case 30: return {
                                                icon: "gi-history" /*"gi-schvyr" /*"fa-file-archive-o" */, tooltip: stav
                                            }; // sejmuto nebo fa-file-text?
                                            default: return null;
                                        }
                                    } else {
                                        return null;
                                    }
                                }
                            })
                            .addTextColumn({
                                caption: "Ixp",
                                name: "ixp_wflspid",
                                width: 100
                            })
                            .addTextColumn({
                                caption: "jres:24450082", //RC 24450082 : IČO
                                name: "ico",
                                width: 65
                            })
                            .addTextColumn({
                                caption: "Kategorie",
                                name: "nazev_kat",
                                width: 120
                            })
                            .addTextColumn({
                                caption: "Název",
                                name: "nazev",
                                width: 150
                            })
                            .addTextColumn({
                                caption: "Značka/Čj",
                                name: "cj",
                                width: 120
                            })
                            .addTextColumn({
                                caption: "Zdroj",
                                name: "nazev_zdroj",
                                width: 120
                            })
                            .addDateColumn({
                                caption: "Vyvěšení",
                                name: "dat_od",
                                width: 80
                            })
                            .addDateColumn({
                                caption: "Sejmutí",
                                name: "dat_do",
                                width: 80
                            })
                            .addTextColumn({
                                caption: "Popis",
                                name: "popis",
                                width: 150
                            })
                            .addTextColumn({
                                caption: "Vyvěšení provedl",
                                name: "nazev_ref",
                                width: 120
                            })
                            .addDateTimeColumn({
                                caption: "Datum změny",
                                name: "dat_zmena",
                                width: 120
                            })
                            .addTextColumn({
                                caption: "Změnu provedl",
                                name: "zmenu_prov_txt",
                                width: 120
                            })
                }).gautofit(); // ggrid

        } // onContentReady

        //-----------------------------------------------------------------------------------------------------
        private nacteniSeznamu(filterModel?: Gordic.Uda.Interface.SeznamDokumentuUDFilterDto): void {
            var that = this;

            // načtení dat do gridu
            if (filterModel === undefined || filterModel === null) {
                this.$filterForm.gfilterpanel("applyFilter");
                // nastavení okna
                that.enable();
            }
            else {
                // načtení dat do seznamu
                filterModel = filterModel || {};
                // zapamatování aktuálního filtru kvůli tiskům
                this.currentFilter = filterModel;
                // TODO: dát sem začátek a konec operace nebo se to tam dělá samo?
                this.call<Gordic.Uda.Interface.SeznamDokumentuUDDto[]>("GetSeznamVyveseni", { filter: filterModel })
                    .done(function (data) {
                        var view = new Gordic.Data.View(data, { key: "ixs_ulo, por_cislo" });
                        // nastavení dat a překreslení gridu
                        that.$grid.ggrid("setData", view);
                        // nastavení okna
                        that.enable();
                    });
            }

        } // nacteniSeznamu

        /**
         * Nastavení prvků ve formuláři
         */
        private enable(): void {

            //// aktuální zápočtový list
            //var aktZL = FucGrid.currentRow<Gordic.Fuc.Interface.GSeznamZapoctovychListuDto>(this.$grid);

            //// akce seznamu
            //this.actions.actPodani!.enabled(this.PovolenoPodani);
            //this.actions.actDetail!.enabled(aktZL !== null);
            //this.actions.actTisk!.enabled(aktZL !== null);
        } // enable

    } // cls
} // ns